const CONTACT_EMAIL = "edifear@gmail.com"; // TODO: replace with your business contact
const COMPANY_NAME = "Chystotil"; // TODO: replace with your legal entity name

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-linen-50">
      <div className="mx-auto max-w-2xl px-4 py-10 pb-20">
        <h1 className="font-serif text-3xl font-medium text-charcoal">
          Terms of Use & Privacy Notice
        </h1>
        <p className="mt-1 text-sm text-charcoal-muted">Virtual Try-On service · Last updated 4 July 2026</p>

        <div className="mt-8 space-y-6 text-sm leading-relaxed text-charcoal">
          <section>
            <h2 className="mb-1 font-serif text-lg">1. What this service does</h2>
            <p>
              This page lets you upload a photo of yourself and a photo of a garment, and
              creates an AI-generated image showing how the garment might look on you. The
              service is provided by {COMPANY_NAME} on behalf of the boutique or seller who
              sent you your personal link.
            </p>
          </section>

          <section>
            <h2 className="mb-1 font-serif text-lg">2. What data we collect</h2>
            <ul className="list-disc space-y-1 pl-5">
              <li>The photos you upload (of yourself and, optionally, of a garment).</li>
              <li>The AI-generated try-on images created from those photos.</li>
              <li>
                Basic technical information about your visit: an anonymous session
                identifier, your device type, and the time of your visits and try-ons.
              </li>
            </ul>
            <p className="mt-2">
              We do not ask for your name, email address, or any account registration.
            </p>
          </section>

          <section>
            <h2 className="mb-1 font-serif text-lg">3. How your photos are used</h2>
            <ul className="list-disc space-y-1 pl-5">
              <li>
                Your photos are used <strong>solely</strong> to generate try-on images at
                your request. Each generation is sent to Google's Gemini image model
                (Google LLC), which acts as our processing provider.
              </li>
              <li>
                Your photos and the generated images are visible to you on this page and
                to the boutique that created your link, so they can assist you with your
                purchase.
              </li>
              <li>
                We do <strong>not</strong> sell your photos, use them for advertising, or
                use them to train AI models.
              </li>
              <li>No biometric identification is performed — we do not use your photos to identify you.</li>
            </ul>
          </section>

          <section>
            <h2 className="mb-1 font-serif text-lg">4. Legal basis and consent</h2>
            <p>
              We process your photos on the basis of your explicit consent (GDPR Art.
              6(1)(a) and Art. 9(2)(a)), which you give before your first try-on. You may
              withdraw your consent at any time by stopping use of the service and
              requesting deletion of your data (see section 6).
            </p>
          </section>

          <section>
            <h2 className="mb-1 font-serif text-lg">5. Storage and retention</h2>
            <p>
              Uploaded photos and generated images are stored on secure cloud
              infrastructure and kept while your try-on link remains active, so you and
              the boutique can review the results. They are deleted when the link is
              removed, or earlier upon your request.
            </p>
          </section>

          <section>
            <h2 className="mb-1 font-serif text-lg">6. Your rights</h2>
            <p>
              You have the right to access, correct, or delete your photos and generated
              images, to withdraw consent, and to lodge a complaint with your data
              protection authority. To exercise any of these rights, contact us at{" "}
              <a className="text-sage-600 underline" href={`mailto:${CONTACT_EMAIL}`}>
                {CONTACT_EMAIL}
              </a>{" "}
              and mention the link address you were given. We respond within 30 days.
            </p>
          </section>

          <section>
            <h2 className="mb-1 font-serif text-lg">7. Acceptable use and age</h2>
            <ul className="list-disc space-y-1 pl-5">
              <li>Only upload photos of yourself, or photos you have permission to use.</li>
              <li>You must be at least 16 years old to use this service.</li>
              <li>Do not upload unlawful, offensive, or explicit content.</li>
            </ul>
          </section>

          <section>
            <h2 className="mb-1 font-serif text-lg">8. Disclaimer</h2>
            <p>
              Try-on images are AI-generated visualisations and may not accurately
              represent how a garment fits, its true colours, or its fabric. They are
              provided "as is" for inspiration only and do not form part of any sales
              contract.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
